var _a;
import { Sizes } from '../../../common/types/Sizes';
export var BadgeStylePropertiesBySize = (_a = {},
    _a[Sizes.LARGE] = {
        height: '40px',
        iconSize: '20px',
        labelSize: Sizes.LARGE,
        gapBetweenContent: '6px',
        leftRightContainerPadding: '5px 12px',
    },
    _a[Sizes.MEDIUM] = {
        height: '32px',
        iconSize: '18px',
        labelSize: Sizes.MEDIUM,
        gapBetweenContent: '6px',
        leftRightContainerPadding: '4px 8px',
    },
    _a[Sizes.SMALL] = {
        height: '24px',
        iconSize: '14px',
        labelSize: Sizes.SMALL,
        gapBetweenContent: '4px',
        leftRightContainerPadding: '2px 6px',
    },
    _a[Sizes.X_SMALL] = {
        height: '16px',
        iconSize: '0px',
        labelSize: Sizes.X_SMALL,
        gapBetweenContent: '0px',
        leftRightContainerPadding: '0px 6px',
    },
    _a);
//# sourceMappingURL=BadgeStylePropertiesBySize.js.map